import { useQuery } from 'react-query';
import { REQUEST_ACTIONS } from '~/Constants/Actions.constants';
import { TIME_VALUES } from '~/Constants/Date.constants';
import { USER_SERVICE_URLS } from '~/Constants/Urls.constants';
import { requestReactQuery } from '~/Helpers/ReactQuery.helper';
import { useProvider } from '~/Hooks';
import { IOrgRole } from '~/Models/DTO/OrgRole.model';
import { IErrorResponse } from '~/Models/DTO/Error.models';

export const useRequestOrgRoles = (_query?: any, props?: { id?: string }) => {
  // we need to load this user from the request because otherwise we have circular dependencies
  const { currentProvider } = useProvider();
  return useQuery<IOrgRole[], IErrorResponse>(
    [REQUEST_ACTIONS.ORG_USER_ROLES, props?.id, currentProvider?.organisationId],
    async () =>
      requestReactQuery<IOrgRole[]>({
        url: USER_SERVICE_URLS.ORG_ROLES,
        config: { method: 'GET' },
        params: {
          page: 1,
          pageSize: 100,
          isDeactivated: false,
          userId: props?.id,
          organisationId: currentProvider?.organisationId,
        },
      }),
    {
      enabled: !!currentProvider?.organisationId,
      initialData: [],
      refetchOnWindowFocus: false,
      refetchOnReconnect: false,
      refetchOnMount: true,
      refetchInterval: TIME_VALUES.HOUR,
    },
  );
};
